import { GroupBase } from 'react-select';
import ReactCreatableSelect, { CreatableProps } from 'react-select/creatable';
import { ISelectOption, ISelectCustomProps } from '../interfaces';
import SelectLayout from '../SelectLayout';

const CreatableSelect = <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
>(selectProps: ISelectCustomProps<SOption, IsMulti, Group> & CreatableProps<SOption, IsMulti, Group>) => (
  <SelectLayout { ...selectProps } component={ ReactCreatableSelect } />
);

export default CreatableSelect;
